export default __webpack_public_path__ + "static/media/illustration-health-2-m.acf327f4.webp";